import { laptopMax, laptopMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import Button from '../buttons/Button';

export const Container = styled.div`
  margin: 30px 0;
  padding: 30px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;

  @media (${laptopMax}) {
    padding: 15px;
    margin: 15px 0;
  }
`;

export const ContentContainer = styled.div<{ alignCenter?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ alignCenter }) =>
    alignCenter
      ? css`
          align-items: center;
        `
      : ''}

  @media (${laptopMin}) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (${laptopMax}) {
    align-items: flex-start;
  }
`;

export const Logo = styled.img`
  width: 200px;
  height: 25px;
`;

export const ContentWrapper = styled.div`
  flex: 1 1 auto;
  @media (${laptopMin}) {
    width: 50%;
  }
`;

export const List = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0 0 30px 0;
`;

export const CalculateButton = styled(Button)`
  background-color: #254055;
  max-width: 180px;
`;
